/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';

/**
 * 
 * @export
 * @interface CalculateTuitionRequest
 */
export interface CalculateTuitionRequest {
    /**
     * 
     * @type {Date}
     * @memberof CalculateTuitionRequest
     */
    calculationDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CalculateTuitionRequest
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CalculateTuitionRequest
     */
    endDate: Date;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CalculateTuitionRequest
     */
    studentId?: ActorActivityRecordActorUserId | null;
}

/**
 * Check if a given object implements the CalculateTuitionRequest interface.
 */
export function instanceOfCalculateTuitionRequest(value: object): value is CalculateTuitionRequest {
    if (!('calculationDate' in value) || value['calculationDate'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    return true;
}

export function CalculateTuitionRequestFromJSON(json: any): CalculateTuitionRequest {
    return CalculateTuitionRequestFromJSONTyped(json, false);
}

export function CalculateTuitionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculateTuitionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'calculationDate': (new Date(json['calculationDate'])),
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'studentId': json['studentId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['studentId']),
    };
}

export function CalculateTuitionRequestToJSON(json: any): CalculateTuitionRequest {
    return CalculateTuitionRequestToJSONTyped(json, false);
}

export function CalculateTuitionRequestToJSONTyped(value?: CalculateTuitionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calculationDate': value['calculationDate'].toISOString().substring(0,10),
        'startDate': value['startDate'].toISOString().substring(0,10),
        'endDate': value['endDate'].toISOString().substring(0,10),
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
    };
}

